import { render, staticRenderFns } from "./DashboardBulkSetup.vue?vue&type=template&id=46b6f58a&scoped=true&"
import script from "./DashboardBulkSetup.vue?vue&type=script&lang=js&"
export * from "./DashboardBulkSetup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBulkSetup.vue?vue&type=style&index=0&id=46b6f58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b6f58a",
  null
  
)

export default component.exports